
const Logout = async (isVoluntary) => {
    return window.UserClientLibs
        && window.UserClientLibs.LogoutAsync
        && await window.UserClientLibs.LogoutAsync({ embedShortCircuit: true, redirectToLogin: true, isVoluntary })
}

export default { Logout }